import VueRouter from 'vue-router'

let routes = [
    {
        path: '/:locale',
        component: require('./views/Main').default,
        children: [
            {
                name: 'person-not-found',
                path: 'person-not-found',
                component: require('./views/PersonNotFound').default,
            },
            {
                name: 'link-expired',
                path: 'link-expired',
                component: require('./views/LinkExpired').default,
            },
            {
                name: 'ocr-rejected',
                path: 'ocr-rejected/:document',
                component: require('./views/OcrRejected').default,
            },
            {
                name: 'ocr-id-singel-sided',
                path: 'ocr-id-singel-sided/:document',
                component: require('./views/OcrIdSingelSided').default,
            },
            {
                name: 'documents',
                path: '/',
                component: require('./views/Documents').default,
            },
            {
                name: 'document-confirm-edit',
                path: 'document-confirm-edit/:document',
                component: require('./views/DocumentConfirmEdit').default,
            },
            {
                name: 'document-upload',
                path: 'document-upload/:document',
                component: require('./views/DocumentUpload').default,
            },
            {
                name: 'document-process',
                path: 'document-process/:document',
                component: require('./views/DocumentProcess').default,
            },
            {
                name: 'document-not-available',
                path: 'document-not-available/:document',
                component: require('./views/DocumentNotAvailable').default,
            },
            {
                name: 'thank-you',
                path: 'thank-you',
                component: require('./views/ThankYou').default,
            },
            {
                name: 'not found',
                path: '*',
                component: require('./views/404').default,
            },
            {
                name: '404',
                path: '404',
                component: require('./views/404').default,
            },
            {
                name: '500',
                path: '500',
                component: require('./views/500').default,
            },
        ]
    },
    {
        path: '*',
        redirect: '/nl'
    }
];

const router = new VueRouter({
    mode: 'history',
    routes,
});


function hasQueryParams(route) {
    return !!Object.keys(route.query).length
}

router.beforeEach((to, from, next) => {
    let query = to.query;
    let $Api = router.app.$Api;
    $Api.token = query.token;
    $Api.uuid = query.uuid;

    Vue.prototype.$DForce.setLanguage(to.params.locale);

    if(!hasQueryParams(to) && hasQueryParams(from)){
        next({name: to.name, params: to.params, query: from.query});
    } else {
        next()
    }
})


export default router;


// WEBPACK FOOTER //
// ./src/routes.js